import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const GisService = {
    dispatchByAttendanceId: (model) => axios.post(API_URL + "/gis/dispatchByAttendanceId", model).then(({data}) => data.data).catch(err => {throw err}),
    setDispatch: (model) => axios.post(API_DESPACHO + "/gis/dispatch/setDispatch/", model).then(({data}) => data.data).catch(err => {throw err}),
    reasons: () => axios.get(API_URL + "/nature/get/dispatchNatures").then(({data}) => data.map(item => ({ value: item.id, label: item.text}))).catch(err => {throw err}),
};

export default GisService;